import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import * as LDClient from 'launchdarkly-js-client-sdk';
import AppliedRoute from '../components/AppliedRoute';
import { Locations } from '../libs/GraphQL';

import ViewInventory from './ViewInventory';
import ViewHealth from './ViewHealth';
import ViewLocationSchedule from './ViewLocationSchedule';
import ScheduleChange from './MassSchedule/MassSchedulingChangeGraphQL';
import LocationForm from './LocationFormGraphQL';
import CreateLocations from './CreateLocations';
import EditLocation from './EditLocationGraphQL';
import ChangeRoutes from './ChangeRoutesGraphQL';
import ListLocation from './ListLocations';
import ChangeWeeklyRoutes from './ChangeWeeklyRoutes/ChangeWeeklyRoutesGraphQL';
import ViewWeeklyRoutes from './ViewWeeklyRoutes';
import ViewFridgeSoftware from './FridgeSoftwareUI/ViewFridgeSoftware';
import ViewInventoryV2 from './ViewInventoryV2';
import SeedFridgeInventory from './SeedFridgeInventory/SeedFridgeInventory';

/* TODO: understand why eslint say that `driverList` unused */
/* eslint-disable react/no-unused-state */
class LocationsWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locations: [],
      driverList: [],
      isLoading: false,
      alertModal: {
        mode: false,
        text: '',
      },
      filters: {
        route: '',
        status: 'LIVE',
        searchBox: '',
        prod: 1,
      },
      user: '',
      allDataLoaded: false,
      lazyLoad: false,
      inventoryV2Enabled: false,
      seedInventoryEnabled: false,
    };

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.driverDropDownList = this.driverDropDownList.bind(this);
  }

  driverDropDownList() {
    return Array.from(
      new Set(
        this.state.locations
          .filter(
            (a) =>
              // eslint-disable-next-line no-prototype-builtins
              a.hasOwnProperty('route') &&
              a.route !== null &&
              a.route.length > 0 &&
              // eslint-disable-next-line no-prototype-builtins
              a.hasOwnProperty('status') &&
              a.status === this.state.filters.status,
          )
          .map(
            (a) =>
              a.route.charAt(0).toUpperCase() + a.route.slice(1).toLowerCase(),
          ),
      ),
    ).sort();
  }

  async fetchLocations(filter = {}, lazyLoad = false) {
    const LSData = JSON.parse(localStorage.getItem('locationsLoaded'));
    const curLocations = LSData?.locations;
    const previousRefresh = LSData?.timeStamp;
    const now = new Date().getTime();
    const diffInMilliseconds = now - previousRefresh;
    const shouldRefresh = diffInMilliseconds / (1000 * 60 * 60 * 24) >= 2;
    // if its been 2 days, force a hard refresh
    if (!lazyLoad || shouldRefresh) {
      this.setState({ isLoading: true });
    } else {
      filter = { count: 2500 };
    }
    if (filter.status === 'OFFLINE') {
      this.setState({ allDataLoaded: true });
    }
    try {
      const locations = await Locations(filter);

      locations.sort((a, b) => {
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;
        return 0;
      });
      // if we are looking for all new updates, just use the new locations as SOT
      const combinedLocations =
        lazyLoad || !curLocations ? locations : curLocations?.concat(locations);
      const stateObject = {
        combinedLocations,
        driverList: Array.from(
          new Set(
            combinedLocations
              .filter(
                (a) =>
                  // eslint-disable-next-line no-prototype-builtins
                  a.hasOwnProperty('route') &&
                  a.route !== null &&
                  a.route.length > 0 &&
                  // eslint-disable-next-line no-prototype-builtins
                  a.hasOwnProperty('status') &&
                  a.status === this.state.filters.status,
              )
              .map(
                (a) =>
                  a.route.charAt(0).toUpperCase() +
                  a.route.slice(1).toLowerCase(),
              ),
          ),
        ).sort(),
      };
      // if we have lazyloaded, we know it queried for all locations
      if (lazyLoad) {
        this.setState({
          allDataLoaded: true,
        });
      }
      // add timestamp to populate "last updated" field
      const obj = {
        locations: combinedLocations,
        driverList: stateObject.driverList,
        allDataLoaded: this.state.allDataLoaded,
      };
      if (
        !localStorage.getItem('locationsLoaded')?.timeStamp ||
        shouldRefresh
      ) {
        obj.timeStamp = new Date().getTime();
      }
      localStorage.setItem('locationsLoaded', JSON.stringify(obj));
      this.setState({
        ...stateObject,
      });
    } catch (e) {
      console.error(e);
      const alertModal = this.state.alertModal;
      alertModal.mode = true;
      const errorString = JSON.stringify(e);
      console.error(errorString);
      alertModal.text =
        'Unable to load locations, Please check your internet and your permissions';
      this.setState({ alertModal });
    }

    this.setState({ isLoading: false });
  }

  async componentDidMount() {
    let lazyLoad = false;
    const currentSession = await Auth.currentAuthenticatedUser();
    this.setState({
      user: currentSession.signInUserSession.idToken.payload.email,
    });
    const LDCUser = {
      key: currentSession.signInUserSession.idToken.payload.email,
    };
    const ldclient = LDClient.initialize(
      process.env.REACT_APP_LAUNCH_DARKLY_CMS
        ? process.env.REACT_APP_LAUNCH_DARKLY_CMS
        : 'nlfaepofjeowiajfpoijewr',
      LDCUser,
    );
    ldclient.on('ready', () => {
      const allFlagsValue = ldclient.allFlags();
      this.setState({
        inventoryV2Enabled: !!allFlagsValue['inventory-page-v2'],
        seedInventoryEnabled: !!allFlagsValue['seed-fridge-inventory'],
      });
    });
    const locationsLoaded = JSON.parse(localStorage.getItem('locationsLoaded'));
    if (locationsLoaded && locationsLoaded.locations) {
      this.setState({
        locations: locationsLoaded.locations,
        driverList: locationsLoaded.driverList,
      });
      if (locationsLoaded.allDataLoaded) {
        this.setState({ allDataLoaded: true });
      }
      this.fetchLocations({}, true);
      lazyLoad = true;
    } else {
      this.fetchLocations({}, false);
    }
    this.setState({ lazyLoad });
  }

  handleFilterChange(event) {
    const filterParameters = this.state.filters;
    filterParameters[event.target.name] = event.target.value;
    const localStorageData = JSON.parse(
      localStorage.getItem('locationsLoaded'),
    );
    if (
      (event.target.value === 'OFFLINE' || event.target.value === '') &&
      !localStorageData.allDataLoaded
    ) {
      this.fetchLocations({ status: 'OFFLINE', count: 2500 }, false);
    }
    this.setState({
      filters: filterParameters,
    });
  }

  convertFromArrayToMap(locations) {
    return locations.reduce(function (acc, cur, i) {
      acc[cur.id] = cur;
      return acc;
    }, {});
  }

  render() {
    const InventoryComponent = this.state.inventoryV2Enabled
      ? ViewInventoryV2
      : ViewInventory;
    return (
      // TODO: Render ALertModal here instead of inside children
      <div>
        <AppliedRoute
          path="/locations/update_routes"
          exact
          component={ChangeRoutes}
          props={{
            locations: this.convertFromArrayToMap(this.state.locations),
          }}
        />
        <AppliedRoute
          path="/locations/update_weekly_routes"
          exact
          component={ChangeWeeklyRoutes}
          props={{
            locations: this.convertFromArrayToMap(this.state.locations),
          }}
        />
        <AppliedRoute
          path="/locations/view_routes"
          exact
          component={ViewWeeklyRoutes}
          props={{
            locations: this.convertFromArrayToMap(this.state.locations),
          }}
        />
        <Route path="/locations/new" exact component={LocationForm} />
        <Route path="/locations/bulk_new" exact component={CreateLocations} />
        <AppliedRoute
          path="/locations/bulk_schedule"
          exact
          component={ScheduleChange}
          props={{
            locations: this.convertFromArrayToMap(this.state.locations),
          }}
        />
        <Route
          path="/locations/fridge_software"
          exact
          component={ViewFridgeSoftware}
        />
        <AppliedRoute
          path="/locations/all"
          exact
          component={ListLocation}
          props={{
            alertModal: this.state.alertModal,
            isLoading: this.state.isLoading,
            locations: this.state.locations,
            driverList: this.driverDropDownList(),
            filters: this.state.filters,
            views: this.props.views,
            lazyLoad: this.state.lazyLoad,
            seedInventoryEnabled: this.state.seedInventoryEnabled,
            handleFilterChange: this.handleFilterChange,
            onClick: () => {
              const alertModal = {
                mode: false,
                text: this.state.alertModal.text,
              };
              this.setState({ alertModal });
            },
          }}
        />
        <Route
          path="/locations/schedule/*"
          exact
          component={ViewLocationSchedule}
        />
        <Route
          path="/locations/inventory/*"
          exact
          component={InventoryComponent}
        />
        <Route path="/locations/detail/*" exact component={EditLocation} />
        <Route path="/locations/health/*" exact component={ViewHealth} />
        {this.state.seedInventoryEnabled && (
          <Route
            path="/locations/inventory-stocking/*"
            exact
            component={SeedFridgeInventory}
          />
        )}
      </div>
    );
  }
}

export default LocationsWrapper;
